import { FC, RefObject } from 'react';
import useVideoSizes from '@anm/hooks/useVideoSizes';
import { ImageWrapper, ProgressiveImageLoadingWrapper, VideoWrapper } from './Wrapper';
import { VideoSizes } from '@anm/hosting-player';
import isMobileOrIpad from '@anm/helpers/is/isMobileOrIPad';

export type PlayerProps = {
  width: number;
  height: number;
  imageSrc?: string;
  container: RefObject<HTMLDivElement>;
  renderVideoPlayer?: (sizes?: VideoSizes) => JSX.Element;
};

const Player: FC<PlayerProps> = ({ renderVideoPlayer, imageSrc, container, width, height }) => {
  const playerSizes = useVideoSizes({ container, fullWidth: isMobileOrIpad(), sizes: { width, height } });

  if (renderVideoPlayer) {
    return <VideoWrapper>{renderVideoPlayer(playerSizes)}</VideoWrapper>;
  }

  if (imageSrc) {
    return (
      <ImageWrapper>
        <ProgressiveImageLoadingWrapper width={width} height={height} imageSrc={imageSrc} />
      </ImageWrapper>
    );
  }

  return null;
};

export default Player;
